<template>
  <div class="sub-wrap">
    <CourseMaterials :class-type-id="classTypeId" />
  </div>
</template>
<script>
import { defineComponent } from 'vue-demi'
import CourseMaterials from '@/components/CourseMaterials.vue'
export default defineComponent({
  components: { CourseMaterials },
  props: {
    classTypeId: Number
  }
})
</script>
<style lang="less" scoped>
.sub-wrap {
  padding: 20px;
}
</style>